import React from 'react'
import {motion} from 'framer-motion'

const Card = ({children, className = '', hover = true, padding = 'p-6', ...props}) => {
  const baseClasses = `
    bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 
    transition-all duration-300 text-gray-900 dark:text-gray-100
    ${padding} ${className}
  `

  return (
    <motion.div
      className={baseClasses}
      whileHover={hover ? { y: -2, boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)' } : {}}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {children}
    </motion.div>
  )
}

export default Card